import * as React from "react"

import { cn } from "@/lib/utils"
import { useIsMobile } from "@/hooks/use-media-query"
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer"

function ResponsiveDialog({ children, ...props }) {
  const isMobile = useIsMobile()

  if (isMobile) {
    return <Drawer {...props}>{children}</Drawer>
  }

  return <Dialog {...props}>{children}</Dialog>
}

function ResponsiveDialogTrigger({ children, ...props }) {
  const isMobile = useIsMobile()

  if (isMobile) {
    return <DrawerTrigger {...props}>{children}</DrawerTrigger>
  }

  return <DialogTrigger {...props}>{children}</DialogTrigger>
}

function ResponsiveDialogContent({ className, children, ...props }) {
  const isMobile = useIsMobile()

  if (isMobile) {
    return (
      <DrawerContent className={cn(className)} {...props}>
        {children}
      </DrawerContent>
    )
  }

  return (
    <DialogContent className={cn(className)} {...props}>
      {children}
    </DialogContent>
  )
}

function ResponsiveDialogHeader({ className, ...props }) {
  const isMobile = useIsMobile()

  if (isMobile) {
    return <DrawerHeader className={cn(className)} {...props} />
  }

  return <DialogHeader className={cn(className)} {...props} />
}

function ResponsiveDialogFooter({ className, ...props }) {
  const isMobile = useIsMobile()

  if (isMobile) {
    return <DrawerFooter className={cn(className)} {...props} />
  }

  return <DialogFooter className={cn(className)} {...props} />
}

function ResponsiveDialogTitle({ className, ...props }) {
  const isMobile = useIsMobile()

  if (isMobile) {
    return <DrawerTitle className={cn(className)} {...props} />
  }

  return <DialogTitle className={cn(className)} {...props} />
}

function ResponsiveDialogDescription({ className, ...props }) {
  const isMobile = useIsMobile()

  if (isMobile) {
    return <DrawerDescription className={cn(className)} {...props} />
  }

  return <DialogDescription className={cn(className)} {...props} />
}

function ResponsiveDialogClose({ className, ...props }) {
  const isMobile = useIsMobile()

  if (isMobile) {
    return <DrawerClose className={cn(className)} {...props} />
  }

  return <DialogClose className={cn(className)} {...props} />
}

export {
  ResponsiveDialog,
  ResponsiveDialogTrigger,
  ResponsiveDialogContent,
  ResponsiveDialogHeader,
  ResponsiveDialogFooter,
  ResponsiveDialogTitle,
  ResponsiveDialogDescription,
  ResponsiveDialogClose,
}
